import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Services', id: 'services' },
    { label: 'Products', id: 'products' },
    { label: 'Business', id: 'business' },
    { label: 'Internet', id: 'internet' },
    { label: 'Installation', id: 'installation' }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    } else {
      console.warn(`Element with id "${id}" not found`);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-12">
            <img 
              src="https://static.readdy.ai/image/96c584895f690011767589183eb2ca42/de1eb034a8050bb932df7f8474b52559.png" 
              alt="SecureHome Logo" 
              className="h-12 w-auto"
            />
            <div className="hidden lg:flex items-center gap-8">
              {menuItems.map((item) => (
                <button 
                  key={item.id}
                  onClick={() => scrollToSection(item.id)} 
                  className={`whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'}`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-4">
            <button 
              onClick={() => scrollToSection('contact')} 
              className={`hidden md:block whitespace-nowrap px-6 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer ${isScrolled ? 'bg-teal-600 text-white hover:bg-teal-700' : 'bg-white text-gray-900 hover:bg-gray-100'}`}
            >
              Get Quote
            </button>
            <button 
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            >
              <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200/20 pt-4">
            <div className="flex flex-col gap-3">
              {menuItems.map((item) => (
                <button 
                  key={item.id}
                  onClick={() => scrollToSection(item.id)} 
                  className={`text-left whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'}`}
                >
                  {item.label}
                </button>
              ))}
              <button 
                onClick={() => scrollToSection('contact')} 
                className={`text-left whitespace-nowrap text-sm font-medium transition-colors cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'}`}
              >
                Contact
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
